import React from 'react';

interface CarouselDirectionNavProps {
  handleGotoNext: () => void;
  handleGotoPrev: () => void;
  totalSlides: number;
  currentIndex: number;
}

function CarouselDirectionNav({
  handleGotoNext,
  handleGotoPrev,
  totalSlides,
  currentIndex,
}: CarouselDirectionNavProps): React.JSX.Element {
  return (
    <ul className="carouselDirectionNav">
      <li className="carouselDirectionNav__item carouselDirectionNav__item--prev">
        <button
          type="button"
          data-testid="carouselPrevButton"
          className="carouselDirectionNav__button"
          onClick={handleGotoPrev}
          aria-label="Previous slide"
          disabled={currentIndex === 0}
        >
          Prev
        </button>
      </li>
      <li className="carouselDirectionNav__item carouselDirectionNav__item--next">
        <button
          type="button"
          data-testid="carouselNextButton"
          className="carouselDirectionNav__button"
          onClick={handleGotoNext}
          aria-label="Next slide"
          disabled={currentIndex === totalSlides - 1}
        >
          Next
        </button>
      </li>
    </ul>
  );
}

export default CarouselDirectionNav;
